<template>
<div>
 <Header @getLanguageMap='getLanguageMap'></Header>
 <div class="crumbs">
  <div class="container">
    <p class="title">{{languageMap['服务支持']}}</p>
    <div class="childs"> <a href="/#/">{{languageMap['主页']}}</a> &gt; <a href="/#/jishu/">{{languageMap['服务支持']}}</a> &gt;  </div>
  </div>
</div>
<!-- <NavigationBar></NavigationBar> -->

<div class="main">
  <div class="container">
  

    <div class="maxTitle"> <span class="title">{{languageMap['服务支持']}}</span>
      <div class="sub"></div>
    </div>

    <div class="mainContent"> 
	  <div v-for="(item,index) in shopList" :key="index" class="child" style="animation: 0.6s ease-in-out 0s 1 normal both running newsChild;">
        <a :href="'/#/jishu/detail?id='+item.id+'&type='+item.type+'&oneId='+oneId">
        <p class="childTitle" v-if="item.name.length > 18">{{item.name.substr(0,18)}}</p>
		<p class="childTitle" v-else>{{item.name}}</p>
        </a>
        <p class="childTime">{{item.updateTime}}</p>
        <a :href="'/#/jishu/detail?id='+item.id+'&type='+item.type+'&oneId='+oneId">
		<p class="childInfo" v-if="item.documentSummary && item.documentSummary.length > 35">{{item.documentSummary.substr(0,35)}}...</p>
        <p class="childInfo" v-else-if="item.documentSummary">{{item.documentSummary}}</p>
        </a> <a class="example-image-link" :href="'/#/jishu/detail?id='+item.id" data-lightbox="child1"></a> 
	  </div>
	
	 <!-- <div class="child" style="animation: 0.6s ease-in-out 0s 1 normal both running newsChild;">
    
        <a href="/#/jishu/wenti/101.html">
        <p class="childTitle">MR{{languageMap['控制器主要的应用场所有哪些？其']}}</p>
        </a>
        <p class="childTime">2018-01-27</p>
        <a href="/#/jishu/wenti/101.html">
        <p class="childInfo">{{languageMap['答']}}：{{languageMap['可使用于']}}：{{languageMap['楼宇、车站、桥梁、商场等楼宇、桥梁亮化项目多采用LED灯管、']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/wenti/101.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 0.2s 1 normal both running newsChild;">
    
        <a href="/#/jishu/wenti/86.html">
        <p class="childTitle">DMX512{{languageMap['控制系统中，控制器带载DMX5']}}</p>
        </a>
        <p class="childTime">2018-01-27</p>
        <a href="/#/jishu/wenti/86.html">
        <p class="childInfo">{{languageMap['答']}}：{{languageMap['在DMX512控制系统中信号传输采用总线制传输方式，该传输方式的特点即为单']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/wenti/86.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 0.4s 1 normal both running newsChild;">
    
        <a href="/#/jishu/wenti/87.html">
        <p class="childTitle">{{languageMap['在TP-LINK TL-SL2428交换机分为新旧两种']}}</p>
        </a>
        <p class="childTime">2018-01-27</p>
        <a href="/#/jishu/wenti/87.html">
        <p class="childInfo">{{languageMap['答']}}：{{languageMap['区别有如下几点']}}：
1、{{languageMap['交换机设置界面的登陆账号与密码有变化，旧版的账']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/wenti/87.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 0.6s 1 normal both running newsChild;">
    
        <a href="/#/jishu/wenti/88.html">
        <p class="childTitle">{{languageMap['客户有一密封灯条每米16点，可以正']}}</p>
        </a>
        <p class="childTime">2018-01-27</p>
        <a href="/#/jishu/wenti/88.html">
        <p class="childInfo">{{languageMap['答']}}：1），{{languageMap['向客户索要版图或原理图']}}
2），{{languageMap['设置一个单红色为一个像素点的灯具']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/wenti/88.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 0.8s 1 normal both running newsChild;">
    
        <a href="/#/jishu/wenti/89.html">
        <p class="childTitle">{{languageMap['客户在测试时候发现，led灯具{{languageMap['显']}}示']}}</p>
        </a>
        <p class="childTime">2018-01-27</p>
        <a href="/#/jishu/wenti/89.html">
        <p class="childInfo">{{languageMap['答']}}： {{languageMap['调整布线文件中的颜色排列。方法有若干种']}}：
1、{{languageMap['观察法，布线设置RGB']}},{{languageMap['显']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/wenti/89.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 1s 1 normal both running newsChild;">
    
        <a href="/#/jishu/wenti/92.html">
        <p class="childTitle">{{languageMap['当时客户使用的单线、双线、四线']}}</p>
        </a>
        <p class="childTime">2018-01-27</p>
        <a href="/#/jishu/wenti/92.html">
        <p class="childInfo">{{languageMap['答']}}：{{languageMap['采用超五类双绞线。']}}
{{languageMap['接法如下']}}：
{{languageMap['橙白、橙、绿白、蓝、蓝白、绿、棕白']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/wenti/92.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 1.2s 1 normal both running newsChild;">
    
        <a href="/#/jishu/wenti/94.html">
        <p class="childTitle">可在测试灯具的时候发现{{languageMap['显']}}示白色</p>
        </a>
        <p class="childTime">2018-01-27</p>
        <a href="/#/jishu/wenti/94.html">
        <p class="childInfo">{{languageMap['答']}}：{{languageMap['多为供电电压不够导致（线细，压差大，开关电源功率不够等），因为红色']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/wenti/94.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 1.4s 1 normal both running newsChild;">
    
        <a href="/#/jishu/wenti/95.html">
        <p class="childTitle">{{languageMap['在使用MP软件导入动画视频素材时，']}}</p>
        </a>
        <p class="childTime">2018-01-27</p>
        <a href="/#/jishu/wenti/95.html">
        <p class="childInfo">{{languageMap['答']}}： {{languageMap['视频导入失败一般原因有两种，']}}
{{languageMap['第一种情况，一般皆为系统中无相关视频']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/wenti/95.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 1.6s 1 normal both running newsChild;">
    
        <a href="/#/jishu/wenti/96.html">
        <p class="childTitle">MR-208{{languageMap['系列控制串联个数受到什么限']}}</p>
        </a>
        <p class="childTime">2018-01-27</p>
        <a href="/#/jishu/wenti/96.html">
        <p class="childInfo">{{languageMap['答']}}：{{languageMap['因为MR控制系统在100Mbps网络环境下采用标准的100Mbps UDP协议， 串联个数受到']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/wenti/96.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 1.8s 1 normal both running newsChild;">
    
        <a href="/#/jishu/wenti/97.html">
        <p class="childTitle">MR-CF01{{languageMap['差分板适用于那些方面？具备']}}</p>
        </a>
        <p class="childTime">2018-01-27</p>
        <a href="/#/jishu/wenti/97.html">
        <p class="childInfo">{{languageMap['答']}}：{{languageMap['差分板使用适用于单线、双线{{languageMap['串行']}}驱动芯片灯具信号衰减的情况。']}}
{{languageMap['我司的']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/wenti/97.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 2s 1 normal both running newsChild;">
    
        <a href="/#/jishu/wenti/98.html">
        <p class="childTitle">{{languageMap['我司MR-208A与MR-308A控制器到第一个灯']}}</p>
        </a>
        <p class="childTime">2018-01-27</p>
        <a href="/#/jishu/wenti/98.html">
        <p class="childInfo">{{languageMap['答']}}： {{languageMap['从控制器到首灯的距离一般为30-60米之间，此距离受驱动芯片类型、信号线']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/wenti/98.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 2.2s 1 normal both running newsChild;">
    
        <a href="/#/jishu/wenti/99.html">
        <p class="childTitle">{{languageMap['测试灯具时，需要确认那些问题？']}}</p>
        </a>
        <p class="childTime">2018-01-27</p>
        <a href="/#/jishu/wenti/99.html">
        <p class="childInfo">{{languageMap['答']}}： {{languageMap['首先要确认灯具的正负极是否有短路情况，可用万用表测试']}}；
{{languageMap['其次要考虑']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/wenti/99.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 2.4s 1 normal both running newsChild;">
    
        <a href="/#/jishu/wenti/100.html">
        <p class="childTitle">MR{{languageMap['控制系统连接方式可分为几种？各']}}</p>
        </a>
        <p class="childTime">2018-01-27</p>
        <a href="/#/jishu/wenti/100.html">
        <p class="childInfo">{{languageMap['答']}}：{{languageMap['常规连接模式为{{languageMap['串行']}}联机，如加设了交换机可采用星形的级联结构。']}}
{{languageMap['串行']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/wenti/100.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 2.6s 1 normal both running newsChild;">
    
        <a href="/#/jishu/wenti/93.html">
        <p class="childTitle">{{languageMap['网线水晶头RJ-45{{languageMap['共']}}有几种压法？交叉']}}</p>
        </a>
        <p class="childTime">2014-12-21</p>
        <a href="/#/jishu/wenti/93.html">
        <p class="childInfo">{{languageMap['网线水晶头RJ-45{{languageMap['共']}}有几种压法？交叉']}}线与直通线的区别是什么？ {{languageMap['答']}}：{{languageMap['标准压法为']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/wenti/93.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 2.8s 1 normal both running newsChild;">
    
        <a href="/#/jishu/wenti/91.html">
        <p class="childTitle">{{languageMap['客户反应控制器和电脑无法连接，']}}</p>
        </a>
        <p class="childTime">2014-12-21</p>
        <a href="/#/jishu/wenti/91.html">
        <p class="childInfo">{{languageMap['客户反应控制器和电脑无法连接，']}}我们如何指导客户{{languageMap['排查问题']}}？ {{languageMap['答']}}：{{languageMap['排查问题']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/wenti/91.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 3s 1 normal both running newsChild;">
    
        <a href="/#/jishu/wenti/90.html">
        <p class="childTitle">{{languageMap['客户在测试时候发现，如果软件设']}}</p>
        </a>
        <p class="childTime">2014-12-21</p>
        <a href="/#/jishu/wenti/90.html">
        <p class="childInfo">{{languageMap['客户在测试时候发现，如果软件设']}}置是什么颜色什么灯不亮，比如软件设置红色...</p>
        </a> <a class="example-image-link" href="/#/jishu/wenti/90.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 3.2s 1 normal both running newsChild;">
    
        <a href="/#/jishu/30.html">
        <p class="childTitle">{{languageMap['玻璃打砂机的{{languageMap['技术特点']}}与工作特点']}}</p>
        </a>
        <p class="childTime">2014-10-03</p>
        <a href="/#/jishu/30.html">
        <p class="childInfo">{{languageMap['技术特点']}}： 1、{{languageMap['自动匀砂系统']}}：{{languageMap['老款机器循环时，砂子落点单一，需人工不停的']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/30.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 3.4s 1 normal both running newsChild;">
    
        <a href="/#/jishu/29.html">
        <p class="childTitle">{{languageMap['玻璃喷砂机的用途是哪些？']}}</p>
        </a>
        <p class="childTime">2014-10-03</p>
        <a href="/#/jishu/29.html">
        <p class="childInfo">1、{{languageMap['自动匀砂系统']}}：{{languageMap['老款机器循环时，砂子落点单一，需人工不停的']}}用耙子来耙...</p>
        </a> <a class="example-image-link" href="/#/jishu/29.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 3.6s 1 normal both running newsChild;">
    
        <a href="/#/jishu/28.html">
        <p class="childTitle">{{languageMap['喷砂机怎样助你高效彻底清理工件']}}</p>
        </a>
        <p class="childTime">2014-10-03</p>
        <a href="/#/jishu/28.html">
        <p class="childInfo">{{languageMap['实践证明']}}：{{languageMap['选用铸铝青铜、硬铝青铜防粘效果较好']}}；{{languageMap['采用碳化钨钢结硬质合金制']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/28.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 3.8s 1 normal both running newsChild;">
    
        <a href="/#/jishu/27.html">
        <p class="childTitle">{{languageMap['玻璃喷砂机是怎样进行工作的？']}}</p>
        </a>
        <p class="childTime">2014-10-03</p>
        <a href="/#/jishu/27.html">
        <p class="childInfo">{{languageMap['喷砂机是采用压缩空气为动力，以形成高速喷射束将喷料']}}({{languageMap['喷丸玻璃珠、钢丸、']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/27.html" data-lightbox="child1"></a> </div><div class="child" style="animation: 0.6s ease-in-out 4s 1 normal both running newsChild;">
    
        <a href="/#/jishu/26.html">
        <p class="childTitle">{{languageMap['怎样选择喷砂设备？']}}</p>
        </a>
        <p class="childTime">2014-10-03</p>
        <a href="/#/jishu/26.html">
        <p class="childInfo">1、{{languageMap['一般而言，喷砂效果主要由零件材料及喷砂磨料决定。根据零件材料的不同']}}...</p>
        </a> <a class="example-image-link" href="/#/jishu/26.html" data-lightbox="child1"></a> </div> -->
		
		
		
		
      <!-- <div class="pages">  <li><span class="pageinfo">{{languageMap['共']}} <strong>1</strong>{{languageMap['页']}}<strong>21</strong>{{languageMap['条记录']}}</span></li>

 </div> -->
    </div>
  </div>
</div>
 <Footer></Footer>
</div>
</template>

<style scoped>
/* news.css */
.mainHead {
	padding-top:40px;
}
.mainHead:after {
	content: "020";
	display: block;
	height: 0;
	clear: both;
	visibility:hidden;
}
.mainHead .left {
	width:435px;
	height:225px;
	line-height:225px;
	float:left;
}
.mainHead .left img {
	vertical-align:middle;
	width:100%;
	height:100%;
}
.mainHead .right {
	position:relative;
	width:656px;
	float:right;
}
.mainHead .right {
	line-height:26px;
	color:#666;
	font-size:14px;
}
.mainHead .right a {
	font-family:Arial, Helvetica, sans-serif;
	color:#0C75D2;
}
.mainContent .child {
	width:285px;
	margin-right:10px;
	vertical-align:text-top;
	padding-top:60px;
	display:inline-block;
*display:inline;
*zoom:1;
}
.mainContent .child .childImg {
	overflow:hidden;
	position:relative;
	width:285px;
	height:190px;
	line-height:212px;
	text-align:center;
}
.mainContent .child .childImg {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.mainContent .child:hover .childImg {
	-webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-moz-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-ms-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-o-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
}
.mainContent .child .childImg .childImgimg {
	width:100%;
	height:100%;
	vertical-align: top;
}
.mainContent .child .childImg .childHide {
	opacity:0;
	position:absolute;
	top:0px;
	left:-100%;
	width:100%;
	height:100%;
	background-image: linear-gradient(top, rgba(232,232,232, 0.8) 0%, rgba(214,214,214, 0.8) 100%);
	background-image: -o-linear-gradient(top, rgba(232,232,232, 0.8) 0%, rgba(214,214,214, 0.8) 100%);
	background-image: -moz-linear-gradient(top, rgba(232,232,232, 0.8) 0%, rgba(214,214,214, 0.8) 100%);
	background-image: -webkit-linear-gradient(top, rgba(232,232,232, 0.8) 0%, rgba(214,214,214, 0.8) 100%);
	background-image: -ms-linear-gradient(top, rgba(232,232,232, 0.8) 0%, rgba(214,214,214, 0.8) 100%);
	background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, rgba(232,232,232, 0.8)), color-stop(1, rgba(214,214,214, 0.8)));
filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#e8e8e8', endColorstr='#d6d6d6'), progid: DXImageTransform.Microsoft.Alpha(Opacity=0);
}
.mainContent .child .childImg .childHide {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.mainContent .child .childImg .childHide .childHideIcon {
	display:inline-block;
*display:inline;
*zoom:1;
	margin:0 2px;
	cursor:pointer;
	width:36px;
	height:36px;
	text-align:center;
	line-height:36px;
	border-radius:36px;
	-moz-border-radius:36px;
	-ms-border-radius:36px;
	-o-border-radius:36px;
	-webkit-border-radius:36px;
	background:#5f5f5f;
}
.mainContent .child .childImg .childHide .childHideIcon {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.mainContent .child .childImg .childHide .childHideIcon:hover {
	background:#000;
}
.mainContent .child .childImg .childHide .childHideIcon img {
	vertical-align:middle;
}
.mainContent .child .childImg:hover .childHide {
	left:0;
	opacity:1;
}
.mainContent .child .childTitle {
	line-height:24px;
	padding:20px 0 0 0;
	color:#333333;
	font-size:14px;
}
.mainContent .child .childTime {
	line-height:22px;
	padding:6px 0;
	color:#999999;
	font-size:12px;
}
.mainContent .child .childInfo {
	line-height:22px;
	font-size:12px;
	color:#666;
}
 @keyframes newsChild {
0% {
opacity:0;
transform:scale(0);
}
100% {
opacity:1;
transform:scale(1);
}
}
@-moz-keyframes newsChild {
0% {
opacity:0;
-moz-transform:scale(0);
}
100% {
opacity:1;
-moz-transform:scale(1);
}
}
@-webkit-keyframes newsChild {
0% {
opacity:0;
-webkit-transform:scale(0);
}
100% {
opacity:1;
-webkit-transform:scale(1);
}
}
@-o-keyframes newsChild {
0% {
opacity:0;
-o-transform:scale(0);
}
100% {
opacity:1;
-o-transform:scale(1);
}
}
@media (max-width: 639px) {
.mainHead {
	padding-top:20px;
}
.mainHead .left {
	width:100%;
	height:auto;
	line-height:normal;
	float:none;
}
.mainHead .right {
	width:100%;
	float:right;
	margin:10px 0 0 0;
}
.mainHead .right {
	line-height:22px;
	font-size:12px;
}
.mainContent .child {
	width:100%;
	margin-right:0px;
	padding-top:30px;
}
.mainContent .child .childImg {
	width:100%;
	height:auto;
	line-height:none;
}
.mainContent .child .childTitle {
	line-height:24px;
	padding:10px 0 0 0;
	font-size:14px;
}
.mainContent .child .childTime {
	line-height:20px;
	padding:4px 0;
	font-size:12px;
}
.mainContent .child .childInfo {
	line-height:20px;
	font-size:12px;
}
}
@media (min-width: 640px) and (max-width:1023px ) {
.mainHead {
	padding-top:40px;
}
.mainHead .left {
	width:100%;
	height:auto;
	line-height:normal;
	float:none;
}
.mainHead .right {
	width:100%;
	float:right;
	margin:20px 0 0 0;
}
.mainHead .right {
	line-height:26px;
	font-size:14px;
}
.mainContent .child {
	width:285px;
	margin-right:10px;
	padding-top:60px;
}
.mainContent .child .childImg {
	width:285px;
	height:212px;
	line-height:212px;
}
.mainContent .child .childTitle {
	line-height:24px;
	padding:20px 0 0 0;
	font-size:14px;
}
.mainContent .child .childTime {
	line-height:22px;
	padding:6px 0;
	font-size:12px;
}
.mainContent .child .childInfo {
	line-height:22px;
	font-size:12px;
}
}
@media (min-width: 1024px) and (max-width:1199px ) {
.mainHead {
	padding-top:30px;
}
.mainHead .left {
	width:355px;
	height:183px;
	line-height:183px;
}
.mainHead .right {
	width:535px;
}
}
@media (min-width: 1200px) and (max-width:1439px ) {
}
@media (min-width: 1440px) and (max-width:1920px ) {
}
.pages {
	text-align:center;
	margin: 64px 0 0 0;
}
.pages a, .pages span {
	display:inline-block;
	padding:9px 14px;
	margin:0 1px;
	border:1px solid #f0f0f0;
	-webkit-border-radius:3px;
	-moz-border-radius:3px;
	border-radius:3px;
}
.pages a, .pages li {
	display:inline-block;
	list-style: none;
	text-decoration:none;
	color:#58A0D3;
}
.pages a.first, .pages a.prev, .pages a.next, .pages a.end {
	margin:0;
}
.pages a:hover {
	border-color:#50A8E6;
}
.pages span.current {
	background:#50A8E6;
	color:#FFF;
	font-weight:700;
	border-color:#50A8E6;
}
/* lightbox.css */
/* {{languageMap['简悦网络（www']}}.jianyuenet.com）{{languageMap['做最好的织梦模板网站 QQ']}}:780000068 */
/* Preload images */
/* body:after {
	content: url(../img/close.png) url(../img/loading.gif) url(../img/prev.png) url(../img/next.png);
	display: none;
} */
.lightboxOverlay {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 9999;
	background-color: black;
 filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=80);
	opacity: 0.8;
	display: none;
}
.lightbox {
	position: absolute;
	left: 0;
	width: 100%;
	z-index: 10000;
	text-align: center;
	line-height: 0;
	font-weight: normal;
}
.lightbox .lb-image {
	display: block;
	height: auto;
	max-width: inherit;
	-webkit-border-radius: 3px;
	-moz-border-radius: 3px;
	-ms-border-radius: 3px;
	-o-border-radius: 3px;
	border-radius: 3px;
}
.lightbox a img {
	border: none;
}
.lb-outerContainer {
	position: relative;
	background-color: white;
 *zoom: 1;
	width: 250px;
	height: 250px;
	margin: 0 auto;
	-webkit-border-radius: 4px;
	-moz-border-radius: 4px;
	-ms-border-radius: 4px;
	-o-border-radius: 4px;
	border-radius: 4px;
}
.lb-outerContainer:after {
	content: "";
	display: table;
	clear: both;
}
.lb-container {
	padding: 4px;
}
.lb-loader {
	position: absolute;
	top: 43%;
	left: 0;
	height: 25%;
	width: 100%;
	text-align: center;
	line-height: 0;
}
.lb-cancel {
	display: block;
	width: 32px;
	height: 32px;
	margin: 0 auto;
	background: url(/templets/111/images/loading.gif) no-repeat;
}
.lb-nav {
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	z-index: 10;
}
.lb-container > .nav {
	left: 0;
}
.lb-nav a {
	outline: none;
	background-image: url('data:image/gif;base64,R0lGODlhAQABAPAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==');
}
.lb-prev, .lb-next {
	height: 100%;
	cursor: pointer;
	display: block;
}
.lb-nav a.lb-prev {
	width: 34%;
	left: 0;
	float: left;
	background: url(/templets/111/images/prev.png) left 48% no-repeat;
 filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
	opacity: 0;
	-webkit-transition: opacity 0.6s;
	-moz-transition: opacity 0.6s;
	-o-transition: opacity 0.6s;
	transition: opacity 0.6s;
}
.lb-nav a.lb-prev:hover {
 filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
	opacity: 1;
}
.lb-nav a.lb-next {
	width: 64%;
	right: 0;
	float: right;
	background: url(/templets/111/images/next.png) right 48% no-repeat;
 filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
	opacity: 0;
	-webkit-transition: opacity 0.6s;
	-moz-transition: opacity 0.6s;
	-o-transition: opacity 0.6s;
	transition: opacity 0.6s;
}
.lb-nav a.lb-next:hover {
 filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
	opacity: 1;
}
.lb-dataContainer {
	margin: 0 auto;
	padding-top: 5px;
 *zoom: 1;
	width: 100%;
	-moz-border-radius-bottomleft: 4px;
	-webkit-border-bottom-left-radius: 4px;
	border-bottom-left-radius: 4px;
	-moz-border-radius-bottomright: 4px;
	-webkit-border-bottom-right-radius: 4px;
	border-bottom-right-radius: 4px;
}
.lb-dataContainer:after {
	content: "";
	display: table;
	clear: both;
}
.lb-data {
	padding: 0 4px;
	color: #ccc;
}
.lb-data .lb-details {
	width: 85%;
	float: left;
	text-align: left;
	line-height: 1.1em;
}
.lb-data .lb-caption {
	font-size: 13px;
	font-weight: bold;
	line-height: 1em;
}
.lb-data .lb-number {
	display: block;
	clear: left;
	padding-bottom: 1em;
	font-size: 12px;
	color: #999999;
}
.lb-data .lb-close {
	display: block;
	float: right;
	width: 30px;
	height: 30px;
	background: url(/templets/111/images/close.png) top right no-repeat;
	text-align: right;
	outline: none;
 filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=70);
	opacity: 0.7;
	-webkit-transition: opacity 0.2s;
	-moz-transition: opacity 0.2s;
	-o-transition: opacity 0.2s;
	transition: opacity 0.2s;
}
.lb-data .lb-close:hover {
	cursor: pointer;
 filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
	opacity: 1;
}

</style>

<script>
import store from "@/store";
import config from "@/config";
import Header from "@/components/front/Header.vue";
import Footer from "@/components/front/Footer.vue";
import NavigationBar from "@/components/front/NavigationBar.vue";

export default {
  data() {
    return {
	  shopTypeId:null,
	  oneId: null,
      shopList:[],
      shopTypeList:[],
      shopTypeObj:{},
      languageMap:{}
    };
  },
  mounted() {
	  this.shopTypeId=this.$route.query.id;
	  this.oneId = this.$route.query.oneId;
       this.queryAllShopType();
       this.addListener();
  },
  beforeDestroy(){

  },
  methods: {
    addListener(){
        let _this=this;
        //this.languageMap['添加控件事件']
        window.addEventListener('jishu', function(event){
			console.log(event.detail)
           _this.queryByParam(event.detail?event.detail:null);
         });
	   },
    queryAllShopType(){
     let url =  config.url + "FrontController/queryAllShopType.action";
      let param = {prentId:15};
      this.$http.post(url, param).then(res => {
        let data = res.data;
        if(data.resultCode == 200){
            this.shopTypeList=data.data;
            this.queryByParam(this.shopTypeId);
        }
      }) .catch(err => {
        console.log(err);
      });
   },
   queryByParam(shopTypeId){
     this.shopTypeId=shopTypeId;
     console.log("shopTypeId=",this.shopTypeId)
     let url =  config.url + "FrontController/queryByParam.action";
      let param = {shopTypeId:shopTypeId};
      this.$http.post(url, param).then(res => {
        let data = res.data;
        if(data.resultCode == 200){
			let shopList=[];
			for(let i=0;i<data.data.length;i++){
				let obj=data.data[i];
				if(obj.type==15 || obj.type==17){
					// if(obj.documentSummary){
                    //    obj.documentSummary=this.languageMap[obj.documentSummary].split("n\\").join('\r\n');
					// }
					// if(obj.name){
					// 	obj.name=this.languageMap[obj.name];
					// }
				  shopList.push(obj);
				}
			}
		   this.shopList=shopList;
        }
      }) .catch(err => {
        console.log(err);
      });

     if(this.shopTypeId){ 
      for(let i=0;i<this.shopTypeList.length;i++){
        let shopTypeObj=this.shopTypeList[i];
         if(this.shopTypeId==shopTypeObj.id){
           this.shopTypeObj=shopTypeObj;
           break;
         }  
      }
     }else{
       this.shopTypeObj={};
     }
   },
   getCookie(name) {  //this.languageMap['获取cookie']
  var arr = null;
  var reg = new RegExp("(^| )"+name+"=([^;]*)(;|$)");
  var arr=document.cookie.match(reg);
  if(arr) {
     return unescape(arr[2]);
  } else {
     return null;
  }
 },
    getLanguageMap(e){
      this.languageMap=e;
      this.$emit('getLanguageMap',e)
    }
  },
  components: {
    Header,
    Footer,
    NavigationBar
  }
};
</script>
